import React, { Component } from 'react';
import Page from '../../../containers/page';

import {
    Container,
    Row,
    Col,
    Modal, ModalHeader, ModalBody, ModalFooter, Button, Input
} from 'reactstrap';

import Isvg from 'react-inlinesvg'

import { API_ENDPOINT } from '../../../constants';
import xIcon from '../../../assets/svg/x.svg';
import FormGroup from 'reactstrap/lib/FormGroup';
import Label from 'reactstrap/lib/Label';
import { Player } from "@lottiefiles/react-lottie-player";
import moment from 'moment';
import notesIcon from '../../../assets/svg/notes-icon.svg';
import attachInvoice from '../../../assets/svg/attach.svg'

import Checkbox from '../../../components/forms/fields/checkbox';
import { getExtendedPaymentManagement, getGroupPaymentMethods, getHumanReadable, getHumanReadableReasonForChange } from '../helper';


function parseText(response) {
    return response.text().then(text => {
        return {
            result: text,
            status: response.status
        }
    })
}
function parseJSON(response) {
    return response.json().then(json => {
        return {
            result: json,
            status: response.status
        }
    })
}
class EditPayment extends Component {
    constructor(props) {
        super(props);

        this.state = {
            ...props.initialData,
            form: {
            },
            paymentMethods: [],
            reasonsForChange: []
        };
    }
    getCurrency = () => {
        return this.props.currency ? this.props.currency : typeof window !== 'undefined' && localStorage?.getItem("currency") ? localStorage.getItem("currency") : '';
    }
    getReasonsForChange = () => {
        const groupData = this.getGroupData();
        const clinicId = this.props.selectedClinic;
        if (!groupData || !clinicId) return;
        const cancellationAndRefundSettings = groupData?.paymentSettings?.cancellationAndRefundSettings?.[clinicId] || null;
        const cancellationReasons = cancellationAndRefundSettings?.cancellationReasons || [];
        let reasonsForChange = [];
        if (cancellationReasons?.length) {
            reasonsForChange = cancellationReasons.map((reason, rIdx) => {
                return {
                    ...reason,
                    key: rIdx
                }
            });
        }
        return reasonsForChange;
    }

    setInitialData = () => {
        const paymentData = this.state.paymentData ?? null;
        const currency = paymentData?.amount?.currency ?? this.getCurrency();
        const messagesToPatient = paymentData?.messagesToPatient || [];
        const lastMessageToPatient = messagesToPatient?.length ? messagesToPatient[messagesToPatient.length - 1]?.message || '' : '';

        let form = {
            patientId: paymentData?.patientData?._id,
            price: paymentData?.amount?.value ? String(paymentData.amount.value) : '0',
            currency: currency,
            addVatRate: paymentData?.vat?.rate ? true : false,
            vatRate: paymentData?.vat?.rate ?? 0,
            paymentMethods: paymentData?.paymentMethods ?? [],
            reasonForChange: -1,
            note: '',
            messageToPatient: lastMessageToPatient ?? '',
            attachedInvoice: paymentData?.attachedInvoice ?? null,
        }

        const reasonsForChange = this.getReasonsForChange() || [];
        // let reasonsForChange = [];
        // for (let i = 0; i < _reasonsForChange.length; i++) {
        //     reasonsForChange.push({
        //         value: _reasonsForChange[i],
        //         label: getHumanReadableReasonForChange(_reasonsForChange[i], this.props.lang)
        //     });
        // }


        this.setState({ form, currency, reasonsForChange }, () => {
            if (this.state.form?.patientId) {
                this.findPatient();
            }
        })
    }
    checkPaymentMethods = () => {

        const groupData = this.getGroupData();

        const paymentMethods = getGroupPaymentMethods(groupData, this.props.lang);

        let setObj = { paymentMethods };

        this.setState(setObj)
    }
    findPatient = () => {
        let form = this.state.form;
        const patientId = form.patientId || null;
        const groupId = this.props.selectedGroup || null;
        if (patientId && patientId?.length === 24 && groupId) {

            fetch(API_ENDPOINT + `/api/payments/patient-data/${groupId}/${patientId}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(res => res.json()).then((result) => {
                if (result?._id) {
                    let patientData = { ...result };
                    let form = {
                        ...this.state.form,
                        patientData: patientData
                    };
                    this.setState({ form }, () => {
                        this.checkPaymentMethods();
                    });
                }
            })

        }
    }


    get = () => {

    }
    getPaymentData = () => {
        const paymentId = this.props.isOpen?.length === 24 ? this.props.isOpen : null;
        if (paymentId) {
            fetch(API_ENDPOINT + `/api/payments/${paymentId}`, {
                method: 'GET',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                }
            }).then(res => res.json()).then((result) => {
                const payment = result ?? null;
                if (!payment || payment?.currentStatus?.status?.key !== 'UNPAID') {
                    this.onClose();
                    return;
                }
                this.setState({ paymentData: payment }, () => {
                    this.setInitialData();
                })
            })
        } else {
            this.onClose();
        }
    }

    componentDidMount() {
        this.get();
        this.getPaymentData();

        this.checkIfExtendedPaymentManagementEnabled();
    }
    checkIfExtendedPaymentManagementEnabled = () => {
        const groupData = this.getGroupData();
        if (groupData?._id) {
            const EXTENDED_PAYMENT_MANAGEMENT = getExtendedPaymentManagement(groupData);
            if (!EXTENDED_PAYMENT_MANAGEMENT) {
                this.onClose();
            }
        }
    }
    componentWillUnmount() {
    }

    componentDidUpdate(prevProps, prevState) {


    }

    getGroupData = () => {
        let selectedGroupIdx = -1;
        if (this.props.uData && this.props.selectedGroup && this.props.uData?.clinicGroups?.length) {
            for (let i = 0; i < this.props.uData.clinicGroups.length; i++) {
                if (this.props.uData.clinicGroups[i]._id == this.props.selectedGroup) {
                    selectedGroupIdx = i;
                    break;
                }
            }
        }
        const groupData = selectedGroupIdx > -1 ? this.props.uData?.clinicGroups?.[selectedGroupIdx] : null;
        return groupData;
    }
    onClose = (callback) => {
        if (this.props.onClose) {
            this.props.onClose(callback);
        }
    }

    uploadDocument = (e) => {
        let input = e.target;
        if (input.files && input.files[0]) {

            let fsize = input.files[0].size;
            let file = Math.round((fsize / 1024))
            this.setState({
                uploadTimestampDoc: Math.floor(new Date().getTime() / 1000)
            })
            if (file > 10240) {
                this.setState({ error: "File size limit has been reached! (max 10 MB)".translate(this.props.lang) })
            } else {

                if (!this.props.handleFileUpload) this.setState({
                    _documentUploading: true
                })

                let formData = new FormData();
                formData.append('file', input.files[0]);
                formData.append('group', this.props.selectedGroup);
                formData.append('fileType', 'invoices')

                if (this.props.handleFileUpload) {
                    this.props.handleFileUpload?.('/data/upload-document', formData)?.then?.(result => {
                        if (result) {
                            this.setState({
                                attachedInvoiceFile: result,
                                _documentUploading: null
                            })
                        }
                    })
                    return;
                }

                fetch(API_ENDPOINT + '/data/upload-document', {
                    method: 'POST',
                    headers: {
                        Accept: 'application/json',
                        'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,

                    },
                    body: formData
                }).then(parseText).then(({ result, status }) => {
                    if (status != 200) {
                        this.setState({ error: result.translate(this.props.lang) })
                    } else {
                        this.setState({
                            attachedInvoiceFile: result,
                            _documentUploading: null
                        })
                    }
                })
            }
        }
    }

    toggleAttachInvoiceModal = () => {
        this.setState({ attachInvoiceModal: !this.state.attachInvoiceModal, attachedInvoiceFile: null })
    }

    selectDifferentPatient = () => {
        let form = this.state.form;
        form.patientData = null;
        form.patientId = null;
        this.setState({ form })
    }
    sendRequest = () => {
        const errors = this.checkValidation();
        if (errors) {
            this.setState({ errors: errors })
            return;
        }
        const form = this.state.form;
        const paymentData = this.state.paymentData;
        const paymentId = paymentData?._id;
        if (!paymentId) {
            return;
        }
        const reasonForChange = this.state.reasonsForChange?.find(r => String(r.key) === String(form?.reasonForChange)) || null;
        const data = {
            ...form,
            reasonForChange: reasonForChange ? { en: reasonForChange.en, se: reasonForChange.se } : null,

        }

        this.setState({ loadingUpdate: true }, () => {
            fetch(API_ENDPOINT + `/api/payments/update/${paymentId}`, {
                method: 'POST',
                headers: {
                    'Authorization': typeof localStorage !== 'undefined' ? `Bearer ${localStorage.getItem('authToken')}` : null,
                    'content-type': 'application/json'
                },
                body: JSON.stringify(data)
            }).then(parseJSON).then(({ result, status }) => {
                this.setState({ loadingUpdate: false }, () => {
                    if (result?.error) {
                        this.setState({ error: result?.error })
                    } else if (result?.success) {
                        this.onClose();
                    }
                })
            })
        })


    }

    checkValidation = () => {
        const form = this.state.form;
        let errors = {};
        if (!form?.patientId) {
            errors.patientId = 'Patient is required'.translate(this.props.lang);
        }
        const price = form?.price && Number(form?.price) ? Number(form?.price) : 0;
        // if (price === 0) {
        //     errors.price = 'Price is required'.translate(this.props.lang);
        // }
        if (price > 0 && !form?.paymentMethods?.length) {
            errors.paymentMethods = 'Payment method is required'.translate(this.props.lang);
        }
        if (
            price > 0
            && form?.paymentMethods?.length === 1
            && form?.paymentMethods?.[0] === 'invoice'
            && !form?.attachedInvoice
        ) {
            errors.attachedInvoice = 'The invoice must be attached'.translate(this.props.lang);
        }


        const reasonForChange = this.state.reasonsForChange?.find(r => String(r.key) === String(form?.reasonForChange)) || null;
        const note = form?.note && form?.note.trim() ? form?.note.trim() : '';
        if (!reasonForChange && this.state.reasonsForChange?.length) errors.reasonForChange = 'Reason for change is required'.translate(this.props.lang);
        const isReasonForChangeOther = reasonForChange && (reasonForChange?.en?.trim().toLowerCase() === 'other' || reasonForChange?.se?.trim().toLowerCase() === 'other');
        if (((!reasonForChange && !errors.reasonForChange) || isReasonForChangeOther) && !note) errors.note = 'Note is required'.translate(this.props.lang);

        return Object.keys(errors).length ? errors : null;
    }
    getBasicPaymentInfo = (data) => {
        const currency = data?.currency;
        const paymentData = this.state.paymentData;
        const questionaryName = paymentData?.caseData?.questionaryName ?? '';
        const caseNumber = paymentData?.paymentNumber ?? '';
        const patientName = paymentData?.patientData?.name ?? '';
        const patientSSN = paymentData?.patientData?.ssn ?? '';
        const price = `${paymentData?.amount?.value} ${paymentData?.amount?.currency ?? currency}`;


        let response = {
            questionaryName: questionaryName,
            price: price,
            caseNumber: caseNumber,
            patientName: patientName,
            patientSSN: patientSSN
        };

        return response;
    }
    render() {
        const isOpen = this.props.isOpen;
        const paymentData = this.state.paymentData;

        if (!paymentData) {
            return null;
        }

        const currency = this.getCurrency();
        const paymentMethods = this.state.paymentMethods ?? [];
        const price = this.state.form?.price && Number(this.state.form?.price) ? Number(this.state.form?.price) : 0;
        const errors = this.state.errors ?? {};

        const basicPaymentInfo = this.getBasicPaymentInfo({ currency });
        return (
            <>
                <Modal isOpen={isOpen} centered className='create-payment-modal-wrap'>
                    <ModalHeader
                        toggle={() => this.onClose()}
                        close={
                            <button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.onClose()}>&times;</button>
                        }
                    >
                        {'Edit payment'.translate(this.props.lang)}
                        {/* <div className='modal-header-subtitle'>
                            {'Patient will be notified of the payment request'.translate(this.props.lang)}
                        </div> */}
                    </ModalHeader>

                    <ModalBody className='create-payment-modal-body'>
                        <Row>
                            <Col lg='12'>
                                <div className='basic-payment-info-wrap'>
                                    <div className='basic-payment-info-item'>
                                        {basicPaymentInfo.questionaryName ? `${basicPaymentInfo.questionaryName} - ` : ''}<span>{basicPaymentInfo.price}</span>
                                    </div>
                                    <div className='basic-payment-info-item'>
                                        {'Case ID'.translate(this.props.lang)}: <span>{basicPaymentInfo.caseNumber}</span>
                                    </div>
                                    <div className='basic-payment-info-item'>
                                        {basicPaymentInfo.patientName} ({basicPaymentInfo.patientSSN})
                                    </div>
                                </div>
                            </Col>
                            <Col lg='6'>
                                <FormGroup className={errors.price ? 'fg-has-error' : ''}>
                                    <Label>{'Price'.translate(this.props.lang)}</Label>
                                    <div className='price-field-wrap'>
                                        <Input
                                            type='text'
                                            value={this.state.form?.price || '0'}
                                            onChange={(e) => {
                                                const value = e.target.value.replace(/\D/g, "");
                                                if (value?.length > 11) return;
                                                let form = this.state.form;
                                                form.price = Number(value);
                                                if (form.price === 0 || !form.price) {
                                                    if (form.addVatRate) {
                                                        form.addVatRate = false;
                                                        form.vatRate = null;
                                                    }
                                                    if (form.paymentMethods?.length) form.paymentMethods = [];
                                                    if (form.attachedInvoice) form.attachedInvoice = null;
                                                }
                                                let setObj = { form };
                                                if (this.state.errors?.price) {
                                                    let errors = this.state.errors;
                                                    delete errors.price;
                                                    setObj.errors = errors;
                                                }
                                                this.setState(setObj);
                                            }}
                                        />
                                        {currency}
                                    </div>
                                    {errors.price ? <div className='error-feedback'>{errors.price}</div> : null}
                                </FormGroup>
                            </Col>
                            <Col lg='6'>
                                <div className='vat-rate-field-wrap'>
                                    <Checkbox
                                        checked={this.state.form?.addVatRate}
                                        onChange={() => {
                                            if (price === 0) return;
                                            let form = this.state.form;
                                            form.addVatRate = !form.addVatRate;
                                            if (!form.addVatRate) {
                                                form.vatRate = null;
                                            }
                                            this.setState({ form });
                                        }}
                                        label={'Add VAT rate'.translate(this.props.lang)}
                                        disabled={price === 0 ? true : false}
                                    />
                                    {
                                        this.state.form?.addVatRate ?
                                            <Input
                                                type='select'
                                                // style={{ width: 200 }}
                                                onChange={(e) => {
                                                    let form = this.state.form;
                                                    form.vatRate = e.target.value;
                                                    this.setState({ form });
                                                }}
                                                value={this.state.form?.vatRate || -1}
                                            >
                                                <option value={-1}>{'VAT-free'.translate(this.props.lang)}</option>
                                                <option value={6}>{'6%'.translate(this.props.lang)}</option>
                                                <option value={12}>{'12%'.translate(this.props.lang)}</option>
                                                <option value={25}>{'25%'.translate(this.props.lang)}</option>


                                            </Input>
                                            :
                                            null
                                    }
                                </div>
                            </Col>
                            {
                                paymentMethods?.length ?
                                    <Col lg='12'>
                                        <FormGroup className={errors.paymentMethods ? 'fg-has-error' : ''}>
                                            <Label>{'Payment method'.translate(this.props.lang)}</Label>
                                            <div className='payment-methods-items-wrap'>
                                                {
                                                    paymentMethods?.map((item, idx) => {
                                                        const isChecked = this.state.form?.paymentMethods?.includes(item.value);
                                                        const isDisabled = price > 0 ? false : true;
                                                        return (
                                                            <div key={idx} className='payment-method-item'>
                                                                <Checkbox
                                                                    checked={isChecked}
                                                                    disabled={isDisabled}
                                                                    onChange={() => {
                                                                        if (isDisabled) return;
                                                                        let form = this.state.form;
                                                                        if (form.paymentMethods?.includes(item.value)) {
                                                                            form.paymentMethods = form.paymentMethods.filter(method => method !== item.value);
                                                                        } else {
                                                                            form.paymentMethods = [...(form.paymentMethods || []), item.value];
                                                                        }
                                                                        let setObj = { form };
                                                                        if (this.state.errors?.paymentMethods) {
                                                                            let errors = this.state.errors;
                                                                            delete errors.paymentMethods;
                                                                            setObj.errors = errors;
                                                                        }
                                                                        this.setState(setObj);
                                                                    }}
                                                                    label={
                                                                        <div style={{ display: 'flex', alignItems: 'center', gap: 15 }}>
                                                                            {item.label}
                                                                            {
                                                                                isChecked && item.value === 'invoice' ?
                                                                                    <div className='icon-with-tooltip-wrap' onClick={(e) => {
                                                                                        e.stopPropagation();
                                                                                        let attachedInvoiceFile = this.state.form?.attachedInvoice ?? null;
                                                                                        this.setState({ attachInvoiceModal: true, attachedInvoiceFile });
                                                                                    }}>
                                                                                        <Isvg src={attachInvoice} className={errors?.attachedInvoice ? 'attached-invoice-icon-error' : this.state.form?.attachedInvoice ? 'attached-invoice-icon' : ''} />
                                                                                        <div className='tooltip-text'>
                                                                                            {
                                                                                                !this.state.form?.attachedInvoice ?
                                                                                                    'Attach invoice'.translate(this.props.lang)
                                                                                                    :
                                                                                                    'Invoice successfully attached'.translate(this.props.lang)
                                                                                            }
                                                                                        </div>
                                                                                    </div>
                                                                                    :
                                                                                    null
                                                                            }
                                                                        </div>
                                                                    }
                                                                />

                                                            </div>
                                                        )
                                                    })
                                                }
                                            </div>
                                            {errors?.paymentMethods ? <div className='error-feedback'>{errors.paymentMethods}</div> : this.state.form?.paymentMethods?.includes('invoice') && errors?.attachedInvoice ? <div className='error-feedback'>{errors.attachedInvoice}</div> : null}
                                        </FormGroup>
                                    </Col>
                                    :
                                    null
                            }

                            <Col lg='12'>
                                <FormGroup className={errors.reasonForChange ? 'fg-has-error' : ''}>
                                    <Label>{'Reason for change'.translate(this.props.lang)}</Label>
                                    <Input
                                        type='select'
                                        value={this.state.form?.reasonForChange || -1}
                                        onChange={(e) => {
                                            let value = e.target.value;
                                            if (!value) value = -1;
                                            let form = this.state.form;
                                            form.reasonForChange = value;
                                            let setObj = { form };
                                            if (this.state.errors?.reasonForChange || this.state.errors?.note) {
                                                let errors = this.state.errors;
                                                delete errors.reasonForChange;
                                                delete errors.note;
                                                setObj.errors = errors;
                                            }
                                            this.setState(setObj);
                                        }}
                                    >
                                        <option value={-1}>{'Select reason'.translate(this.props.lang)}</option>
                                        {
                                            this.state.reasonsForChange?.map((item, idx) => {
                                                let reason = item?.[this.props.lang] ? item?.[this.props.lang] : item?.['se'];
                                                return <option value={item?.key}>{reason}</option>
                                            })
                                        }


                                    </Input>
                                    {errors.reasonForChange ? <div className='error-feedback'>{errors.reasonForChange}</div> : null}
                                </FormGroup>
                            </Col>

                            <Col lg='12'>
                                <FormGroup className={errors.note ? 'fg-has-error' : ''}>
                                    <Label>{'Note'.translate(this.props.lang)}</Label>
                                    <Input
                                        type='textarea'
                                        value={this.state.form?.note || ''}
                                        style={{ height: 100 }}
                                        onChange={(e) => {
                                            let form = this.state.form;
                                            form.note = e.target.value;
                                            let setObj = { form };
                                            if (this.state.errors?.note) {
                                                let errors = this.state.errors;
                                                delete errors.note;
                                                setObj.errors = errors;
                                            }
                                            this.setState(setObj);
                                        }}
                                    />
                                    {errors.note ? <div className='error-feedback'>{errors.note}</div> : null}
                                </FormGroup>
                            </Col>
                            <Col lg='12'>
                                <FormGroup>
                                    <Label className='note-label-wrap'>
                                        {'Message to patient'.translate(this.props.lang)}
                                        <div className='notes-icon-wrap'>
                                            <Isvg src={notesIcon} />
                                            <div className='tooltip-text'>{'Message to patient tooltip'.translate(this.props.lang)}</div>
                                        </div>
                                    </Label>
                                    <Input
                                        type='textarea'
                                        value={this.state.form?.messageToPatient || ''}
                                        style={{ height: 100 }}
                                        onChange={(e) => {
                                            let form = this.state.form;
                                            form.messageToPatient = e.target.value;
                                            this.setState({ form });
                                        }}
                                    />
                                </FormGroup>
                            </Col>
                        </Row>





                    </ModalBody>
                    <ModalFooter className='modal-footer-buttons-wrap'>
                        <Button
                            color="primary"
                            onClick={() => this.sendRequest()}
                            disabled={this.state.loadingUpdate}
                        >
                            {'Save'.translate(this.props.lang)}
                        </Button>
                        <Button color="primary" className='red-button' onClick={() => this.onClose()}>{'Cancel'.translate(this.props.lang)}</Button>

                    </ModalFooter>
                </Modal>

                <input ref={(node) => this.documentInput = node} type="file" accept=".pdf" key={this.state.uploadTimestampDoc} onChange={this.uploadDocument} style={{ pointerEvents: 'none', opacity: 0 }} />

                {
                    this.state.attachInvoiceModal ?
                        <Modal
                            isOpen={this.state.attachInvoiceModal}
                            centered
                            toggle={() => this.toggleAttachInvoiceModal()}
                        >
                            <ModalHeader toggle={() => this.toggleAttachInvoiceModal()} close={<button type="button" className="close" style={{ position: 'absolute', top: '15px', right: '15px' }} onClick={() => this.toggleAttachInvoiceModal()}><Isvg src={xIcon} /></button>}>{'Attach invoice'.translate(this.props.lang)}</ModalHeader>

                            <ModalBody style={{ width: '100%' }}>

                                <button
                                    className={this.state._documentUploading ? 'attach-invoice uploading' : this.state.attachedInvoiceFile ? 'attach-invoice uploaded' : "attach-invoice"}
                                    onClick={() => {
                                        if (this.documentInput) this.documentInput.click()
                                    }}
                                >
                                    <div className="button-menu-icon-wrap">
                                        <Isvg src={attachInvoice} />
                                    </div>
                                    <div className='chat-icons-text'>
                                        {
                                            this.state.attachedInvoiceFile ?
                                                'File uploaded'.translate(this.props.lang)
                                                :
                                                'Attach file'.translate(this.props.lang)
                                        }
                                    </div>
                                </button>


                            </ModalBody>
                            <ModalFooter className='buttons-right-blue'>
                                <Button
                                    color='primary'
                                    disabled={!this.state.attachedInvoiceFile}
                                    onClick={() => {
                                        let form = this.state.form;
                                        form.attachedInvoice = this.state.attachedInvoiceFile;
                                        let setObj = { form };
                                        if (this.state.errors?.attachedInvoice) {
                                            let errors = this.state.errors;
                                            delete errors.attachedInvoice;
                                            setObj.errors = errors;
                                        }
                                        this.setState(setObj, () => {
                                            this.toggleAttachInvoiceModal();
                                        });
                                    }}
                                >
                                    {'Save'.translate(this.props.lang)}
                                </Button>
                                <Button color='primary' onClick={() => this.toggleAttachInvoiceModal()}>{'Close'.translate(this.props.lang)}</Button>

                            </ModalFooter>


                        </Modal>
                        :
                        null
                }

                {this.state._documentUploading ?
                    <div className="file-progress-loader">
                        <div>
                            <Player
                                onEvent={(event) => {
                                    if (event === "load" && this.player && this.player.current) this.player.current.play();
                                }}
                                ref={this.player} // set the ref to your class instance
                                autoplay={true}
                                loop={true}
                                controls={true}
                                src="/lf30_editor_l5cxzdyf.json"
                                renderer={'svg'}
                                style={{ height: "128px", width: "128px", }}
                            ></Player>
                            <h6>{'Processing file...'.translate(this.props.lang)}</h6>
                        </div>
                    </div>
                    : null}

            </>
        );
    }
}


export default EditPayment;